import script from "./InspectorTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectorTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./InspectorTemplate.vue?vue&type=style&index=0&id=68ca3da8&scoped=true&lang=scss"
import "./InspectorTemplate.vue?vue&type=style&index=1&id=68ca3da8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ca3da8"]])

export default __exports__